var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBatteryLeft(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 272,
    height: 378,
    viewBox: "0 0 272 378",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M204.733 209.317L201.89 219.85C201.652 220.782 200.688 221.366 199.743 221.073L199.675 221.031L160.488 210.514L160.42 210.473C159.488 210.234 158.904 209.271 159.197 208.326L162.04 197.793L204.733 209.317Z",
    fill: "#CEB04F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M177.909 138.72L162.047 197.823L204.763 209.287L220.625 150.183L177.909 138.72Z",
    fill: "#70BBAC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M224.059 137.299L220.572 150.201L177.838 138.746L181.324 125.843C181.563 124.912 182.526 124.327 183.471 124.621L222.781 135.166C223.767 135.391 224.352 136.354 224.059 137.299Z",
    fill: "#CEB04F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M159.211 208.381C158.972 209.312 159.502 210.289 160.433 210.528L160.502 210.569L199.688 221.086L199.757 221.128C200.688 221.366 201.665 220.837 201.903 219.905L204.746 209.372L162.012 197.916L159.211 208.381Z",
    fill: "#FFAE5D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M222.836 135.153L183.526 124.607C182.594 124.369 181.618 124.898 181.379 125.83L177.893 138.732L220.627 150.188L224.113 137.286C224.352 136.354 223.767 135.391 222.836 135.153Z",
    fill: "#FFAE5D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.13,
    d: "M190.589 127.307C190.4 126.771 189.949 126.357 189.374 126.148L183.526 124.607C183.033 124.495 182.58 124.547 182.167 124.764C181.754 124.982 181.437 125.35 181.324 125.843L177.838 138.746L161.998 197.862L159.156 208.394C159.043 208.888 159.096 209.341 159.313 209.753C159.53 210.166 159.885 210.429 160.392 210.596L160.46 210.638L166.186 212.15L166.254 212.192C166.815 212.346 167.42 212.198 167.847 211.803C168.082 211.571 168.303 211.284 168.387 210.914L171.23 200.382L187.069 141.266L190.556 128.363C190.695 127.98 190.669 127.637 190.589 127.307Z",
    fill: "#0B0207"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M160.502 210.569L199.688 221.086C199.268 222.703 197.576 223.64 195.959 223.219L162.635 214.298C161.06 213.809 160.081 212.185 160.502 210.569Z",
    fill: "#247467"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M221.754 134.776L184.69 124.847C185.124 123.285 186.748 122.307 188.31 122.741L219.648 131.157C220.456 131.367 221.043 131.864 221.437 132.525C221.832 133.185 221.964 133.968 221.754 134.776Z",
    fill: "#247467"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M216.827 130.332L191.159 123.442C191.467 122.319 192.595 121.694 193.718 122.002L215.4 127.828C215.962 127.982 216.399 128.341 216.684 128.795C216.847 129.221 216.926 129.784 216.827 130.332Z",
    fill: "#6EBBAB"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M207.364 306.888L161.029 356.508C158.256 359.456 153.632 359.595 150.698 356.877L55.2506 267.821C52.303 265.048 52.1089 260.438 54.8823 257.49L101.217 207.87C103.991 204.922 108.601 204.728 111.548 207.501L207.009 296.612C209.943 299.33 210.082 303.954 207.364 306.888Z",
    fill: "#1D7469"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M102.62 206.299L56.8568 255.337L162.996 354.388L208.76 305.349L102.62 206.299Z",
    fill: "#FFAE5D"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M65.8029 234.739L52.3354 249.205C51.7834 249.805 51.8332 250.725 52.4337 251.277L56.8692 255.375L72.3786 238.78L67.9431 234.682C67.2742 234.088 66.3549 234.138 65.8029 234.739Z",
    fill: "#5CA493"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M70.4198 240.772L65.9843 236.674C65.3838 236.122 64.6024 236.021 64.1885 236.472L54.2673 247.103C53.8533 247.553 53.9862 248.336 54.5867 248.888L59.0222 252.986L70.4198 240.772Z",
    fill: "#6EBBAB"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M67.7844 243.57L63.3489 239.471C62.7484 238.919 62.0916 238.614 61.9121 238.832L57.3448 243.732C57.1653 243.95 57.4911 244.569 58.0916 245.121L62.5271 249.22L67.7844 243.57Z",
    fill: "#ABD9CE"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M90.0188 211.361L79.6837 222.442C79.2697 222.893 79.2658 223.592 79.7162 224.006L83.1008 227.139L94.9673 214.461L91.5827 211.328C91.1189 210.859 90.4328 210.911 90.0188 211.361Z",
    fill: "#5CA493"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M93.5325 215.976L90.1478 212.843C89.6975 212.429 89.0944 212.344 88.7634 212.657L81.2017 220.791C80.8708 221.105 81.0183 221.709 81.4821 222.178L84.8667 225.31L93.5325 215.976Z",
    fill: "#6EBBAB"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M91.5455 218.091L88.1609 214.958C87.7105 214.544 87.2455 214.309 87.1075 214.459L83.6026 218.225C83.4646 218.376 83.6952 218.843 84.1456 219.257L87.5302 222.39L91.5455 218.091Z",
    fill: "#ABD9CE"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M123.972 81.2213C124.061 79.9187 125.15 78.8959 126.453 78.9854L145.514 80.0368C146.817 80.1262 147.84 81.2155 147.75 82.5182L143.018 169.719C142.928 171.022 141.839 172.045 140.536 171.955L121.475 170.904C120.173 170.814 119.15 169.725 119.239 168.422L123.972 81.2213Z",
    fill: "#6EBBAC"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M141.094 78.1469L131.07 77.6254C130.178 77.5519 129.42 78.261 129.347 79.1522L142.621 79.87C142.681 78.9238 141.972 78.1655 141.094 78.1469Z",
    fill: "#247467"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M135.865 173.329L125.841 172.807C124.949 172.733 124.24 171.975 124.314 171.084L137.588 171.802C137.569 172.679 136.811 173.389 135.865 173.329Z",
    fill: "#247467"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M139.578 76.9452L132.68 76.5917C132.09 76.5611 131.512 77.0517 131.481 77.6413L140.627 78.1443C140.7 77.4863 140.222 76.9625 139.578 76.9452Z",
    fill: "#6EBBAB"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M134.254 174.362L127.357 174.009C126.767 173.978 126.29 173.454 126.307 172.81L135.454 173.313C135.423 173.902 134.899 174.38 134.254 174.362Z",
    fill: "#6EBBAB"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M138.457 161.052C138.23 164.892 134.976 167.782 131.15 167.61C127.311 167.383 124.421 164.13 124.593 160.304C124.82 156.464 128.073 153.574 131.899 153.746C135.725 153.918 138.683 157.213 138.457 161.052Z",
    fill: "#1D7467"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M131.728 157.339L131.363 163.949",
    stroke: "#4ABCAD",
    strokeWidth: 0.2856,
    strokeMiterlimit: 10
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M142.346 89.9507C142.119 93.7902 138.866 96.6803 135.04 96.5084C131.2 96.2815 128.31 93.0283 128.482 89.2022C128.709 85.3627 131.962 82.4725 135.788 82.6445C139.614 82.8164 142.573 86.1111 142.346 89.9507Z",
    fill: "#1D7467"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M135.663 85.4695L135.206 93.615",
    stroke: "#4ABCAD",
    strokeWidth: 0.3536,
    strokeMiterlimit: 10
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M139.507 89.7703L131.362 89.314",
    stroke: "#4ABCAD",
    strokeWidth: 0.3536,
    strokeMiterlimit: 10
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M103.577 110.711C104.256 111.825 103.851 113.263 102.736 113.943L86.3041 123.66C85.1893 124.34 83.7512 123.934 83.0715 122.82L38.534 47.7065C37.8543 46.5917 38.26 45.1536 39.3748 44.4739L55.8065 34.7566C56.9214 34.0769 58.3594 34.4826 59.0392 35.5975L103.577 110.711Z",
    fill: "#6EBBAC"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M91.0412 122.795L99.6839 117.658C100.441 117.182 100.721 116.182 100.245 115.425L88.8084 122.234C89.2844 122.991 90.2708 123.216 91.0412 122.795Z",
    fill: "#247467"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M42.4266 40.7596L51.0693 35.6221C51.8263 35.1462 52.8261 35.4261 53.3021 36.1831L41.8656 42.9924C41.3897 42.2354 41.6146 41.249 42.4266 40.7596Z",
    fill: "#247467"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M93.0019 122.957L98.9472 119.409C99.4564 119.11 99.6385 118.426 99.3261 117.861L91.4405 122.523C91.7529 123.087 92.4378 123.269 93.0019 122.957Z",
    fill: "#6EBBAB"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M43.1634 39.0081L49.1087 35.4606C49.6179 35.1617 50.3577 35.3303 50.6566 35.8395L42.7711 40.5011C42.4721 39.9919 42.6542 39.307 43.1634 39.0081Z",
    fill: "#6EBBAB"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M47.0811 52.4311C45.1103 49.1281 46.231 44.8957 49.479 42.9383C52.782 40.9675 57.0144 42.0882 58.9718 45.3362C60.9426 48.6391 59.8219 52.8715 56.5739 54.8289C53.3393 56.8413 49.0519 55.734 47.0811 52.4311Z",
    fill: "#1D7467"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M54.7666 51.7189L51.4095 46.0764",
    stroke: "#4ABCAD",
    strokeWidth: 0.2856,
    strokeMiterlimit: 10
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M83.4645 113.7C81.4937 110.397 82.6144 106.165 85.8624 104.207C89.1654 102.237 93.3978 103.357 95.3552 106.605C97.326 109.908 96.2053 114.141 92.9573 116.098C89.6543 118.069 85.367 116.962 83.4645 113.7Z",
    fill: "#1D7467"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M91.4892 113.662L87.3304 106.644",
    stroke: "#4ABCAD",
    strokeWidth: 0.3536,
    strokeMiterlimit: 10
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M85.9006 112.232L92.9192 108.073",
    stroke: "#4ABCAD",
    strokeWidth: 0.3536,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBatteryLeft);
export default __webpack_public_path__ + "static/media/batteryLeft.04c6ef2ba3d86771005cdc685e2fc8f1.svg";
export { ForwardRef as ReactComponent };